export { default } from "./CURPField";
